<template>
  <div class="container">
    <div class="news_detail_banner">
      <router-link class="link" to="/index">
        <img src="@/assets/images/home.svg" />
      </router-link>
      <span class="divide"> > </span>
      <router-link class="link" to="/news"> News & Stories </router-link>
      <span class="divide"> > </span>
      <router-link class="link" to=""> {{ newsDetail.title }} </router-link>
    </div>
    <div class="news_detail_wrapper">
      <div class="news_detail" v-html="newsDetail.details"></div>
      <div class="give_now_content">
        <div class="label">Trust in God Offering</div>
        <div class="description">
          A time to reflect on how far God has brought us and respond in faith for what’s ahead.
        </div>
        <div class="btn" @click="open = true">Give Now</div>
      </div>
    </div>
    <a-modal class="custom_modal" v-model:open="open" :closable="false" :footer="null">
      <div class="tag">Thank you for your dedication!</div>
      <Payment :dedicateId="newsDetail.newsId" />
    </a-modal>
  </div>
</template>

<script setup>
import { LoadingOutlined } from '@ant-design/icons-vue';
import { message } from 'ant-design-vue';
import { computed, ref, reactive, onMounted, toRaw, h, nextTick, watch } from 'vue';
import { useRoute } from 'vue-router';
import { useStore } from 'vuex';

import { fetchNewsDetail } from '@/api/common.js';
import Payment from '@/components/Payment.vue';

const route = useRoute();
const store = useStore();
const open = ref(false);
const newsDetail = reactive({
  newsId: '',
  title: '',
  details: '',
  description: '',
});

const getNewsDetail = () => {
  fetchNewsDetail(route.params.id).then((res) => {
    if (res.code == 200) {
      Object.assign(newsDetail, res.data);
    }
  });
};

onMounted(() => {
  getNewsDetail();
});
onMounted(() => {});
</script>

<style lang="less">
.custom_modal {
  .ant-modal-content {
    border-radius: 20px;
    .payment_wrapper {
      margin-top: 80px;
    }
    .tag {
      position: absolute;
      border-radius: 20px 20px 0 0;
      left: 0;
      right: 0;
      top: 0;
      height: 64px;
      background: #05644f;
      font-size: 20px;
      font-weight: bold;
      line-height: 64px;
      color: #ffffff;
      text-align: center;
    }
  }
}
.news_detail {
  img,
  iframe,
  video {
    border-radius: 8px;
    max-width: 100%;
  }
}
@media (max-width: 768px) {
  .news_detail {
    img,
    iframe,
    video {
      height: auto;
    }
  }
}
</style>

<style lang="less" scoped>
.container {
  margin: 40px auto;
  width: 1080px;
  .news_detail_banner {
    margin: 32px auto;
    .divide {
      margin: 0 12px;
    }
    .link {
      color: #3d3d3d;
      text-decoration: none;
      cursor: pointer;
      line-height: 24px;
    }
  }
  .news_detail_wrapper {
    display: flex;
    gap: 20px;
    .news_detail {
      flex: 1;
      background: #f7f7f7;
      border-radius: 16px;
      padding: 32px;
      line-height: normal;
    }
    .give_now_content {
      width: 252px;
      border-radius: 16px;
      background: #f7f7f7;
      padding: 24px;
      line-height: 24px;
      height: fit-content;
      .label {
        font-weight: bold;
        color: #3d3d3d;
      }
      .description {
        margin-bottom: 16px;
      }
      .btn {
        border-radius: 100px;
        background: #05644f;
        color: #ffffff;
        font-size: 14px;
        font-weight: bold;
        line-height: 28px;
        padding: 8px 20px;
        display: inline-block;
        cursor: pointer;
      }
    }
  }
}
@media (max-width: 768px) {
  .container {
    width: 100%;
    padding: 0 24px;
    .news_detail_banner {
      margin: 12px auto 24px;
    }
    .news_detail_wrapper {
      flex-wrap: wrap;
      .news_detail {
        width: 100%;
        padding: 12px;
      }
      .give_now_content {
        width: 100%;
      }
    }
  }
}
</style>
